// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleTimestamp_root__3Icpi","link":"ArticleTimestamp_link__2qjO7"};